import { render, staticRenderFns } from "./errDataTipModal.vue?vue&type=template&id=a76b3428&scoped=true"
import script from "./errDataTipModal.vue?vue&type=script&lang=js"
export * from "./errDataTipModal.vue?vue&type=script&lang=js"
import style0 from "./errDataTipModal.vue?vue&type=style&index=0&id=a76b3428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76b3428",
  null
  
)

export default component.exports